import { Download, Heart, Shield, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer({ apiUrl, onDownload }) {

  return (
    <>
      {/* Download CTA Section */}
      <section
        data-testid="download-cta-section"
        className="py-24 md:py-32 px-6 md:px-12 lg:px-24"
      >
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display font-extrabold text-[#09090B] text-3xl sm:text-4xl lg:text-5xl tracking-tight mb-6">
            Ready to Import?
          </h2>
          <p className="text-[#52525B] text-base md:text-lg max-w-lg mx-auto mb-10">
            Download the plugin, install in WordPress, and start importing Amazon products
            in under 5 minutes.
          </p>
          <button
            data-testid="footer-download-btn"
            onClick={onDownload}
            className="inline-flex items-center gap-3 bg-[#FF7300] text-white hover:bg-[#E66800] hover:shadow-xl transition-all rounded-md px-10 py-5 font-bold text-xl border-0 cursor-pointer animate-pulse-glow"
          >
            <Download size={22} />
            Download Plugin ZIP
          </button>
          <p className="text-xs text-[#A1A1AA] mt-5">
            GPL v2 License &middot; WordPress 5.8+ &middot; PHP 7.4+
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer
        data-testid="footer"
        className="border-t border-[#E4E4E7] py-8 px-6 md:px-12 lg:px-24"
      >
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <div className="w-6 h-6 rounded bg-[#FF7300] flex items-center justify-center">
              <span className="text-white font-display font-bold text-xs">A</span>
            </div>
            <span className="font-display font-bold text-[#09090B] text-sm tracking-tight">
              AmznAWP
            </span>
            <span className="bg-[#F3F4F6] text-[#52525B] px-2 py-0.5 rounded text-xs font-mono">
              v1.0.0
            </span>
          </div>

          <div className="flex items-center gap-6 text-sm text-[#52525B]">
            <a href="#features" className="hover:text-[#09090B] transition-colors no-underline">Features</a>
            <a href="#pricing" className="hover:text-[#09090B] transition-colors no-underline">Pricing</a>
            <a href="#docs" className="hover:text-[#09090B] transition-colors no-underline">Docs</a>
            <a href="#faq" className="hover:text-[#09090B] transition-colors no-underline">FAQ</a>
            <Link to="/refund-policy" className="hover:text-[#09090B] transition-colors no-underline flex items-center gap-1" data-testid="footer-refund-link">
              <Shield size={12} /> Refund Policy
            </Link>
            <Link to="/portal" className="hover:text-[#09090B] transition-colors no-underline flex items-center gap-1" data-testid="footer-portal-link">
              My Account
            </Link>
            <Link to="/contact" className="hover:text-[#09090B] transition-colors no-underline flex items-center gap-1" data-testid="footer-contact-link">
              <MessageSquare size={12} /> Contact
            </Link>
          </div>

          <div className="text-xs text-[#A1A1AA] flex items-center gap-1">
            Built with <Heart size={12} className="text-[#FF7300]" /> for WordPress
          </div>
        </div>
      </footer>
    </>
  );
}
